import TextBox from "components/TextBox";
import MasterPage2Column from "pages/MasterPage2Column"
import * as urls from "../../../api/urls";
import { useCallback, useEffect, useRef, useState } from "react";
import { Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";
import AppSimpleBar from "components/AppSimpleBar";
import Loader from "components/Loader";
import DatePicker from "react-datepicker";
import classnames from "classnames";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { FormControlLabel, Radio, RadioGroup, Switch } from "@mui/material";
import LoadingIconWithText from "components/LoadingIconWithText";
import { QuickReplyContentTypes as Types } from "const";
import ReactQuill from "react-quill";
import { Tab, Tabs } from "react-bootstrap";
import { debounce, last, set } from "lodash";

// import ImageResize from 'quill-image-resize-module-react';
// import WorkplaceQuill from "components/WorkplaceQuill";
import { UserTypes } from "api";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
// ReactQuill.Quill.register('modules/imageResize', ImageResize);

// interface tb_QuickReply {
//   quickReplyId?: number | null;
//   category?: string | null;
//   name?: string | null;
//   keyword?: string | null;
//   description?: string | null;
//   avaliableFrom?: Date | null;
//   avaliableTo?: Date | null;
//   createBy?: number | null;
//   createDate?: Date | null;
//   updateBy?: number | null;
//   updateDate?: Date | null;
//   usedCount?: number | null;
//   enabled?: boolean | null;
//   active?: boolean | null;
//   items?: tb_QuickReplyItem[] | null;
// }

interface tb_NotificationGlobal {
  noticeId?: string | null;
  title?: string | null;
  body?: string | null;
  bodyHtml?: string | null;
  seq?: number | null;
  effectiveDateFrom?: Date | null;
  effectiveDateTo?: Date | null;
  createDate?: Date | null;
  createDateTime?: Date | null;
  createBy?: number | null;
  published?: boolean | null;
  forCustomer?: boolean | null;
  forSupplier?: boolean | null;
  forEmployee?: boolean | null;
  totalRead?: number | null;
}


interface tb_QuickReplyItem {
  uid?: string;
  quickReplyId?: number | null;
  seq?: number | null;
  contentType?: Types;
  contents?: string | null;
  contentName?: string | null;
  enabled?: boolean | null;
}

interface ModalData {
  uid?: string;
  contentType?: Types;
  contentName?: string | null;
  text?: string | null;
  sticker?: string | null;
  picture?: string | null;
  linkUrl?: string | null;
  linkCaption?: string | null;
}

const CategoryList: React.FC<
  { onClickItem(editId: string | null): void, editId: string | null, isSearching: boolean, noticeList: tb_NotificationGlobal[], onSearch(filter: string): void, canEdit: boolean }> =
  ({ onClickItem, editId, isSearching, noticeList, onSearch, canEdit }) => {
    const [filter, setFilter] = useState<string>("");
    return (
      <>
        <div className="mpage-2col-header">
          <div>รายการประกาศ</div>
          <div>
            {/* <i className="fas fa-plus-circle hover hand" onClick={() => { onClickItem(-1) }}></i>&nbsp; */}
            {canEdit && (
              <button className="btn btn-pc btn-warning" onClick={() => { onClickItem("") }} >เพิ่มใหม่</button>
            )}
            {/* <i className="fas fa-redo-alt" onClick={() => { }}></i> */}
          </div>
        </div>
        <TextBox placeholder="กรอง/ค้นหา" className="form-control p-1" icon13small={true} icon13css="fas fa-search" onEnter13={(e) => onSearch(filter)} value={filter} onChange={(e) => setFilter(e.target.value)} />
        <AppSimpleBar className="mt-1" style={{ height: "calc(100vh - 160px)" }}>
          {isSearching && (<Loader />)}
          {noticeList.length <= 0 && (<div className="text-center">-- ยังไม่มีข้อมุล --</div>)}
          <div className="d-flex flex-column" style={{ gap: "4px" }}>
            {noticeList.map((ntc, index) => {
              return (
                <div key={index}
                  className={classnames("dset-qr-cat hover hand d-flex justify-content-between align-items-center", { "active-primary": editId === ntc.noticeId, "text-secondary": !ntc.published })}
                  onClick={() => onClickItem(ntc.noticeId ? ntc.noticeId : null)}
                >
                  <div style={{ flex: "1" }}>
                    {ntc.title ?? ""}
                  </div>
                  <div>
                    <span className="fz-08 text-secondary me-2 ">{ntc.totalRead && Utils.FormatNumber(ntc.totalRead, 0)}</span>
                    {/* <span className="badge badge-soft-secondary rounded p-1 me-1 bg-secondary">C</span>
                    <span className="badge badge-soft-secondary rounded p-1 me-1 bg-secondary">S</span>
                    <span className="badge badge-soft-secondary rounded p-1 me-1 bg-secondary">E</span> */}
                  </div>
                </div>
              )
            })}
          </div>
        </AppSimpleBar>

      </>);
  }

const HtmlEditorWithImage: React.FC = () => {
  const [value, setValue] = useState('');
  const quillRef = useRef<ReactQuill>(null);

  // Custom image handler for local upload
  const handleImageUpload = () => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.onchange = async () => {
      if (input.files && input.files[0]) {
        const file = input.files[0];
        const reader = new FileReader();

        reader.onload = () => {
          const quill = quillRef.current?.getEditor();
          const range = quill?.getSelection(true);
          if (range) {
            // quill.insertEmbed(range.index, 'image', reader.result);
          }
        };

        reader.readAsDataURL(file); // Convert image to base64
      }
    };
  };

  const modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link', 'image'], // image button
        ['clean'],
      ],
      handlers: {
        image: handleImageUpload, // override default image handler
      },
    },
    imageResize: {}, // optional
  };

  return (
    <div>

      <div style={{ marginTop: 20 }}>
        <h4>HTML Output:</h4>
        <div style={{ border: '1px solid #ccc', padding: 10 }}>
          <div dangerouslySetInnerHTML={{ __html: value }} />
        </div>
      </div>
    </div>
  );
};

const ReadStatTabTitle: React.FC<{ caption: string, loading: boolean, count: number }> = ({ caption, loading, count }) => {
  return (
    <span>
      {caption} (
      {loading && (
        <span className="spinner-border spinner-border-sm" role="status" />
      )}
      {!loading && (<>{Utils.FormatNumber(count, 0)}</>)}
      )
    </span>
  );
}

const ReadStatTabUserList: React.FC<{ users: any[], fieldDate: string | null }> = ({ users, fieldDate }) => {
  return (
    <AppSimpleBar style={{ height: "170px" }}>
      <ul className="list-unstyled">
        {
          (users).map((ee: any, index: number) => {
            return (
              <li key={index} className="mb-2 hover " >
                <div className="d-flex justify-content-between">
                  <div>
                    {index + 1}.&nbsp;
                    {ee.userTypeText}:&nbsp;
                    {ee.displayName2}
                  </div>
                  {fieldDate && (
                    <div>
                      {fieldDate == "lastConnectDate" ? (<>{Utils.GetLastOnlineText(ee[fieldDate])}</>) : (<>{Utils.GetShortDateTimeToShowInChat(ee[fieldDate], false)}</>)}
                    </div>
                  )}
                </div>
              </li>)
          })
        }
      </ul>
    </AppSimpleBar>
  );
}

const ReadStatTab: React.FC<{ tabName: string, tabCaption: string, isLoading: boolean, userList: any[] }> = ({ tabName, tabCaption, isLoading, userList }) => {
  const count = userList.length;
  return (
    <Tab eventKey={tabName} title={
      <span>
        {tabCaption} (
        {isLoading && (
          <span className="spinner-border spinner-border-sm" role="status" />
        )}
        {!isLoading && (<>{Utils.FormatNumber(count, 0)}</>)}
        )
      </span>
    }>
    </Tab>
  );
};
// https://codesandbox.io/p/sandbox/react-quill-with-react-typescript-fgs2vb?file=%2Fsrc%2FApp.tsx
const NotificationEdit: React.FC<{ editId: string | null, onNoticeChange(noticeId: string | null, data: tb_NotificationGlobal | null): void, canEdit: boolean }> = ({ editId, onNoticeChange, canEdit }) => {
  const quillRef = useRef<ReactQuill | null>(null);
  const [showMore, setShowMore] = useState<boolean>(false);
  const [editData, setEditData] = useState<tb_NotificationGlobal | null>(null);
  const [editItems, setEditItems] = useState<tb_QuickReplyItem[]>([]);
  const [modalData, setModalData] = useState<ModalData | null>(null);
  const [modalSaving, setModalSaving] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const iconShowMore = showMore ? "fas fa-angle-double-up" : "fas fa-angle-double-down";
  const stickerList: string[] = [
    "/icons/stk/555.png",
    "/icons/stk/Annoucement.png",
    "/icons/stk/AppreciateYourHelp.png",
    "/icons/stk/Bye.png",
    "/icons/stk/CallBackLater.png",
    "/icons/stk/CarIsGoing.png",
    "/icons/stk/Checking.png",
    "/icons/stk/CheckOrder.jpeg",
    "/icons/stk/Confirm.png",
    "/icons/stk/Cry.png",
    "/icons/stk/Deliveried.png",
    "/icons/stk/Document.png",
    "/icons/stk/Done1.png",
    "/icons/stk/Done2.png",
    // "/icons/stk/EV1.png",
    // "/icons/stk/EV2.PNG",
    // "/icons/stk/EV3.PNG",
    "/icons/stk/Execelent.png",
    "/icons/stk/HappyBirthDay.png",
    "/icons/stk/Hello.png",
    "/icons/stk/Hello2.png",
    "/icons/stk/Hi.PNG",
    "/icons/stk/Hurry.png",
    "/icons/stk/Love.png",
    "/icons/stk/Mail.png",
    "/icons/stk/Miss2s.png",
    "/icons/stk/MoreInfo.png",
    "/icons/stk/MyVolume.png",
    "/icons/stk/NewProduct.PNG",
    "/icons/stk/Oh.png",
    "/icons/stk/Ok.png",
    "/icons/stk/Please1.PNG",
    "/icons/stk/Please2.png",
    "/icons/stk/Processing.png",
    "/icons/stk/ProductInterest.png",
    "/icons/stk/Quotation.png",
    "/icons/stk/ReadyDelivery.png",
    "/icons/stk/Rest.png",
    "/icons/stk/Rich.png",
    "/icons/stk/Roger.png",
    "/icons/stk/Slip.png",
    "/icons/stk/Sorry.jpeg",
    "/icons/stk/Sorry2.png",
    "/icons/stk/SpecialPrice.png",
    "/icons/stk/TakeCare.png",
    "/icons/stk/ThankForPayment.jpeg",
    "/icons/stk/ThankYou.png",
    "/icons/stk/Tired.png",
    "/icons/stk/Tuy.png",
    "/icons/stk/WaitMoment.png",
    "/icons/stk/Welcome.png",
    "/icons/stk/WhereDelivery.png",
    "/icons/stk/Worth.png"
  ];
  const hdrText = editId === null
    ? "ยังไม่ได้เลือก"
    : (!editId)
      ? "เพิ่มประกาศใหม่" : "รายละเอียด";

  const [statLoading, setStatLoading] = useState<boolean>(false);
  const [userAcccept, setUserAcccept] = useState<any[]>([]);
  const [userRead, setUserRead] = useState<any[]>([]);
  const [userNotRead, setUserNotRead] = useState<any[]>([]);

  const debounceSearchStat = useCallback(
    debounce((noticeId) => {
      try {
        setStatLoading(true);
        if (noticeId) {
          new APIClient().fnPostForm(urls.NOTIFICATION_GLOBAL_LOAD_READSTAT, { noticeId: noticeId })
            .then(rs => {
              // console.log('NOTIFICATION_GLOBAL_LOAD_READSTAT:', rs);
              const ar = rs as any[];
              const accept = ar.filter(x => x.acceptDateTime != null);
              const read = ar.filter(x => x.readDateTime != null);
              const other = ar.filter(x => x.readDateTime == null);
              // console.log({ accept, read, other });

              setUserAcccept(accept);
              setUserRead(read);
              setUserNotRead(other);

              setStatLoading(false);
            })
            .catch(er => {
              Utils.HandleException(er, false);
              setStatLoading(false);
            });

        } else {
          setUserAcccept([]);
          setUserRead([]);
          setUserNotRead([]);
          setStatLoading(false);
        }
      } catch (e) {
        Utils.HandleException(e, false);
        setStatLoading(false);
      }
    }, 800),
    []
  );

  useEffect(() => {
    // console.log('editId is chnage to ' + editId);
    setModalData(null);
    if (editId === null) { // nothing
      setEditData(null);
      setEditItems([]);
    } else if (!editId) { // new
      setEditData({
        published: true,
        title: "",
        body: "",
        bodyHtml: "",
        forCustomer: false,
        forSupplier: false,
        forEmployee: false
      });
      setEditItems([getNewItem()]);
    } else { // load from database
      setIsLoading(true);
      debounceSearchStat(editId);
      const api = new APIClient();
      api.fnPostForm(urls.NOTIFICATION_GLOBAL_SEARCH, { noticeId: editId })
        .then(rs => {
          // console.log('rs:', rs);
          setEditData(rs[0]);
          // const newItems = rs.items.map((x: any) => ({ ...x, uid: Utils.GetUniqueId() }));
          // setEditItems(newItems);
          // setShowMore(rs.category || rs.description || rs.avaliableFrom || rs.avaliableTo);
          setIsLoading(false);
        })
        .catch(e2 => {
          Utils.HandleException(e2, true);
          setEditData(null);
          // setEditItems([]);
          setIsLoading(false);
        });
    }
  }, [editId]);

  const [isSaving, setIsSaving] = useState<boolean>(false);
  const onSave = () => {
    try {
      if (!editData) {
        alert('กรุณาระบุหัวข้อ');
        return;
      }
      if (!editData.title) {
        alert('กรุณาระบุหัวข้อ');
        return;
      }
      setIsSaving(true);
      const dataToSave = { ...editData };
      dataToSave.body = quillRef.current?.getEditor().getText();
      console.log('datatoSave:', dataToSave);
      const api = new APIClient();
      api.fnPostBody(urls.NOTIFICATION_GLOBAL_SAVE, dataToSave)
        .then(rs => {
          // console.log('NOTIFICATION_GLOBAL_SAVE:', rs);
          const rs2 = rs as tb_NotificationGlobal;
          setEditData(prev => ({ ...prev, noticeId: rs2.noticeId }));
          onNoticeChange(rs2.noticeId ? rs2.noticeId : null, rs2);
          setIsSaving(false);
        })
        .catch(er => {
          Utils.HandleException(er, true);
          setIsSaving(false);
        });
    } catch (e) {
      Utils.HandleException(e, true);
      setIsSaving(false);
    }
  }

  const onDelete = () => {
    Utils.SweetConfirm("ยืนยันการลบข้อมูล").then(x => {
      if (x.isConfirmed) {
        new APIClient().fnPostForm(urls.NOTIFICATION_GLOBAL_DEL, { noticeId: editData?.noticeId })
          .then(rs => {
            onNoticeChange(editData?.noticeId ? editData?.noticeId : null, null);
          })
          .catch(er => {
            Utils.HandleException(er, true);
          });
      }
    });
  }

  const Header: React.FC<{}> = ({ }) => {
    return (
      <div className="mpage-2col-header">
        <div>{hdrText}</div>
        <div className="d-flex" style={{ gap: "10px" }}>
          {(editData && canEdit) && (
            <>
              {editData?.noticeId && (<button className="btn btn-pc btn-danger" onClick={onDelete} >ลบข้อมูล</button>)}
              {/* <button className="btn btn-pc btn-warning" >ยกเลิก</button> */}
              <button className="btn btn-pc btn-primary" onClick={onSave} >
                {isSaving && (<><LoadingIconWithText loadingText={""}></LoadingIconWithText>&nbsp;</>)}
                บันทึก
              </button>
            </>
          )}
        </div>
      </div>
    );
  }

  // const [editUid, setEditUid] = useState<string>("");


  const onTextChange = (value: string) => {
    setModalData(prev => ({ ...prev, text: value }))
  }

  const onConfirmModalAsync = async (): Promise<tb_QuickReplyItem | null> => {
    const rs: tb_QuickReplyItem = {};
    rs.contentType = modalData?.contentType;
    rs.contentName = modalData?.contentName;

    if (modalData?.contentType === Types.Text) {
      rs.contents = modalData?.text?.replaceAll('\n', '<br/>');
      return rs;
    } else if (modalData?.contentType === Types.Sticker) {
      rs.contents = modalData?.sticker;
      return rs;
    } else if (modalData?.contentType === Types.Picture || modalData?.contentType === Types.File) {
      const isImage = modalData?.contentType === Types.Picture;
      const input = isImage ? modalPictureRef.current : modalFileRef.current;
      if (!input || !input.files || input.files.length <= 0) throw new Error('ยังไม่ได้เลือกไฟล์');

      // upload picture
      const file = input.files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("isImage", isImage ? "true" : "false");
      const response = await fetch(process.env.REACT_APP_APIURL + urls.QUICK_REPLY_UPLOAD_FILE, {
        method: "POST",
        body: formData,
        credentials: "include",
        headers: {
          'Authorization': `Bearer ${Utils.JwtTokenGet()}` // 20250708
        }
      });
      const rs2 = await response.json();
      // console.log('rs2:', rs2);
      const errMsg =
        rs2.errors && rs2.errors[""] && rs2.errors[""].length > 0
          ? rs2.errors[""][0]
          : null;

      if (rs2.error) {
        throw new Error(rs2.error);
      } else if (errMsg) {
        throw new Error(errMsg);
      } else if (rs2.title) {
        throw new Error(rs2.title);
      } else {
        rs.contents = isImage ? rs2.urlThumb : rs2.url;
        rs.contentName = file.name;
        return rs;
      }
    } else if (modalData?.contentType === Types.Link) {
      rs.contents = modalData.linkUrl;
      rs.contentName = modalData.linkCaption ?? modalData.linkUrl;
      return rs;
    }
    return null;
  }

  const onConfirmModal = () => {
    setModalSaving(true);
    try {
      // console.log('edititem:', editItems);
      // console.log('modal:', modalData);

      onConfirmModalAsync().then(rs => {
        if (rs) {
          setEditItems(prev => prev.map(xx => xx.uid == modalData?.uid ? ({
            ...xx,
            contentType: rs.contentType,
            contents: rs.contents,
            contentName: rs.contentName,
          }) : xx));
          setModalData(null);
        } else {
          alert('No data');
        }
        setModalSaving(false);
      }).catch(e => { alert(e.message); setModalSaving(false); });
    } catch (e) {
      Utils.HandleException(e, true);
      setModalSaving(false);
    }
  }

  // useEffect(() => { console.log('editItems:', editItems); }, [editItems]);

  const onClickEdit = (e: any, uid: string) => {
    // If the clicked element is inside an <a> tag, skip processing
    const anchor = (e.target as HTMLElement).closest('a');
    if (anchor) return;

    // console.log('click uid = ' + uid);
    //const found = editItems.find(x => x.uid === uid); // not create new object
    const found = { ...editItems.find(x => x.uid === uid) }; // create new object
    if (found) {
      const newContent = found.contents?.replaceAll("<br/>", "\n").replaceAll("<br>", "\n");
      setModalData({
        uid: found.uid,
        contentType: found.contentType,
        text: found.contentType === Types.Text ? newContent : "",
        sticker: found.contentType === Types.Sticker ? newContent : "",
        picture: found.contentType === Types.Picture ? newContent : "",
        linkUrl: (found.contentType === Types.File || found.contentType === Types.Link) ? newContent : "",
        linkCaption: (found.contentType === Types.File || found.contentType === Types.Link) ? found.contentName : "",
      });
    }
  }

  const setModalType = (val: any) => {
    const type = parseInt(val) as Types;
    setModalData(prev => ({
      ...prev
      , contentType: type
    }));
  }

  const onChooseSticker = (url: string, close: boolean) => {
    setModalData(prev => ({ ...prev, sticker: url }));
    if (close) {
      onConfirmModal();
    }
  }

  // useEffect(() => { console.log('modalData:', modalData); }, [modalData]);

  const modalPictureRef = useRef<HTMLInputElement>(null);
  const modalFileRef = useRef<HTMLInputElement>(null);

  const handleModalPictureClick = () => {
    modalPictureRef.current?.click(); // Trigger the file input dialog
  };

  const handleModalPictureChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setModalData(prev => ({ ...prev, picture: e.target?.result as string }))
        // setImageSrc(e.target?.result as string); // Update the image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const swapEditItems = (seq1: number, direction: number) => {
    const seq2 = seq1 + direction;

    const total = editItems.length;
    if (seq1 == seq2 || seq1 < 0 || seq2 < 0 || seq1 > total || seq2 > total) return;
    // console.log('swap from ' + seq1 + ' to ' + seq2);

    setEditItems(prevItems => {
      // Clone the array to avoid mutation
      const newItems = [...prevItems];

      // Find the two items by index value
      const item1 = newItems.find(x => x.seq === seq1);
      const item2 = newItems.find(x => x.seq === seq2);

      if (!item1 || !item2) return prevItems; // Nothing to swap

      // Swap their index values
      const temp = item1.seq;
      item1.seq = item2.seq;
      item2.seq = temp;

      return [...newItems];
    });
  };

  const getNewItem = () => {
    return {
      uid: Utils.GetUniqueId(),
      quickReplyId: -1,
      seq: editItems.length + 1,
      contentType: Types.Text,
      contents: "",
      enabled: true,
    };
  }

  const addEditItems = () => {
    setEditItems(prev => [...prev, getNewItem()]);
  }

  if (editId === null) return (<Header />);
  return (
    <div style={{ position: "relative" }}>
      {isLoading && (<Loader />)}
      <Header />
      <div className="row">
        <div className="col">
          หัวข้อ
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <FormControlLabel
            control={
              <Switch checked={editData?.published ?? false}
                onChange={(e) => setEditData(p => ({ ...p, published: canEdit ? e.target.checked : p?.published }))}
              />
            }
            label={editData?.published ? "เผยแพร่" : "ยังไม่เผยแพร่"}
          />
          {editData?.noticeId && (<>[{editData?.noticeId}]</>)}
          <TextBox className="form-control p-1" value={editData?.title ?? ""} onChange={(e) => setEditData(p => ({ ...p, title: e.target.value }))}></TextBox>
        </div>
      </div>
      <div className="row">
        <div className="col">
          วันที่มีผล
          <DatePicker
            selected={editData?.effectiveDateFrom}
            onChange={(date: any) => setEditData(p => ({ ...p, effectiveDateFrom: date }))}
            dateFormat={"dd/MM/yyyy"} isClearable className="form-control p-1" portalId="root-portal"></DatePicker>
        </div>
        <div className="col">
          ถึงวันที่
          <DatePicker
            selected={editData?.effectiveDateTo}
            onChange={(date: any) => setEditData(p => ({ ...p, effectiveDateTo: date }))}
            dateFormat={"dd/MM/yyyy"} isClearable className="form-control p-1" portalId="root-portal"></DatePicker>
        </div>
        <div className="col">
          ลำดับ
          <TextBox className="form-control p-1" value={editData?.seq ? editData?.seq?.toString() : ""} onChange={(e) => setEditData(p => ({ ...p, seq: Utils.ToNumber(e.target.value, null) }))}></TextBox>
        </div>
      </div>
      <div className="row">
        <div className="col">
          {/* รายละเอียด */}
          <div >
            <ReactQuill ref={quillRef} theme="snow" className="data-setting-quill-container" value={editData?.bodyHtml} onChange={(content: any) => setEditData(p => ({ ...p, bodyHtml: content }))} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          ประกาศ สำหรับ
          &nbsp;
          <input id="chkCustomer" type="checkbox" checked={editData?.forCustomer ?? false} onChange={(e) => setEditData(p => ({ ...p, forCustomer: e.target.checked }))}></input>
          <label htmlFor={"chkCustomer"}>ลูกค้า</label>&nbsp;&nbsp;
          <input id="chkSupplier" type="checkbox" checked={editData?.forSupplier ?? false} onChange={(e) => setEditData(p => ({ ...p, forSupplier: e.target.checked }))}></input>
          <label htmlFor={"chkSupplier"}>Suppier</label>&nbsp;&nbsp;
          <input id="chkEmployee" type="checkbox" checked={editData?.forEmployee ?? false} onChange={(e) => setEditData(p => ({ ...p, forEmployee: e.target.checked }))}></input>
          <label htmlFor={"chkEmployee"}>พนักงาน</label>&nbsp;&nbsp;
        </div>
      </div>

      <div className="row">
        <div className="col">
          <Tabs defaultActiveKey="tab1" id="controlled-tab-example">
            <Tab eventKey="tab1" title={<ReadStatTabTitle caption="รับทราบแล้ว" loading={statLoading} count={userAcccept.length} />}>
              <ReadStatTabUserList users={userAcccept} fieldDate={"acceptDateTime"} />
            </Tab>
            <Tab eventKey="tab2" title={<ReadStatTabTitle caption="อ่านแล้ว" loading={statLoading} count={userRead.length} />}>
              <ReadStatTabUserList users={userRead} fieldDate={"readDateTime"} />
            </Tab>
            <Tab eventKey="tab3" title={<ReadStatTabTitle caption="ยังไม่อ่าน" loading={statLoading} count={userNotRead.length} />}>
              <ReadStatTabUserList users={userNotRead} fieldDate={"lastConnectDate"} />
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>

  );
}

const DataSettingNotificationGlobal = () => {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (p2) => ({
      isAdmin: p2.isAdmin,
    })
  );
  const { isAdmin } = useAppSelector(storeData);

  const [isSearching, setIsSearching] = useState<boolean>(false);
  const canEdit = isAdmin;
  // const [categories, setCategories] = useState<any[]>([]);
  const [noticeList, setNoticeList] = useState<tb_NotificationGlobal[]>([]);
  // const [editData, setEditData] = useState<tb_QuickReply | null>(null);
  // useEffect(() => {
  //   console.log('noticeList:', noticeList);
  // }, [noticeList]);
  const onSearch = (filter: string) => {
    try {
      const api = new APIClient();
      setIsSearching(true);
      api.fnPostForm(urls.NOTIFICATION_GLOBAL_SEARCH, { keyword: filter })
        .then(rs => {
          // console.log('NOTIFICATION_GLOBAL_SEARCH:', rs);
          setNoticeList(rs);
          // setCanEdit(rs.canEdit);
          setIsSearching(false);
        })
        .catch(e2 => {
          Utils.HandleException(e2, true);
          setIsSearching(false);
        });
    } catch (e) {
      Utils.HandleException(e, true);
      setIsSearching(false);
    }
  }

  useEffect(() => {
    onSearch("");
  }, []);

  const [editId, setEditId] = useState<string | null>(null);
  const onClickItem = (editId: string | null) => {
    setEditId(editId);
    // setEditCol2Key(editId);
  }

  // const [editCol2Key, setEditCol2Key] = useState<any>(null);
  const onSetEditCol2Key = (key: any) => {
    setEditId(key);
  }

  const onNoticeChange = (noticeId: string | null, data: tb_NotificationGlobal | null) => {
    // console.log('onCatChange:', { quickReplyId, data });
    if (data == null) { // delete
      setNoticeList(prev => prev.filter(p => p.noticeId !== noticeId));
      setEditId(null);
      // setEditCol2Key(null);
    } else { // update
      const found = noticeList.some(x => x.noticeId === noticeId);
      if (found) { // update existing
        setNoticeList(prev => prev.map(p => p.noticeId === noticeId ? ({
          ...p,
          title: data.title,
          published: data.published,
        }) : p));
      } else { // add new
        setNoticeList(prev => [...prev, data]);
        setEditId(data.noticeId ? data.noticeId : null);
        // setEditCol2Key(data.quickReplyId ?? -1);
      }
    }
  }

  return (
    <MasterPage2Column
      titleText="ข้อมูล ประกาศ"
      titleIcon="fas fa-bullhorn"
      editCol2Key={editId}
      onSetEditCol2Key={onSetEditCol2Key}
      // capCol2={title2}
      componentCol1={<CategoryList onClickItem={onClickItem} editId={editId} isSearching={isSearching} noticeList={noticeList} onSearch={onSearch} canEdit={canEdit} />}
      componentCol2={<NotificationEdit editId={editId} onNoticeChange={onNoticeChange} canEdit={canEdit} />}
    ></MasterPage2Column>
  );
}

export default DataSettingNotificationGlobal;